// extracted by mini-css-extract-plugin
export default {"top":"HeaderAssets_top__ko8ya","box":"HeaderAssets_box__SDkmV","addButton":"HeaderAssets_addButton__r+ZzL"};